import React from 'react';
import PropTypes from 'prop-types';


const InfoBanner = ({
  section,
  tittle,
  readingTime,
  keywords,
  urlMobile,
  urlDesktop,
}) => {

  const [width, setWidth] = React.useState(window.innerWidth)
  const breakpoint = 620

  React.useEffect(() => {
    const saveWidth = () => {
      setWidth(window.innerWidth)
    }

    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener('resize', saveWidth)

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    return () => window.removeEventListener('resize', saveWidth)
  }, [])

  return (
    <div className="col-md-12 imgMain paddingRightLeft0 tittle-right">
      <span>
        <img
          alt={section}
          className="img-responsive"
          src={
            width < breakpoint
              ? urlMobile
              : urlDesktop
          }
        ></img>
      </span>
      <div className="tittle-left">
        <h1 className="titleNews" dangerouslySetInnerHTML={{ __html: tittle }}></h1>
        <div className='contentKeywords'>
          {
           keywords && keywords.map((word, index)=>{
                return(
                  <div key={`keyword-${index}`} className='keywords'>
                    <label>{ word }</label>
                  </div>
                )
            })
          }
        </div>
        <p className="authorNews">
          { readingTime }
        </p>
      </div>
    </div>
  )
};

InfoBanner.propTypes = {
  section: PropTypes.string.isRequired,
  tittle: PropTypes.string.isRequired,
  readingTime: PropTypes.string,
  keywords: PropTypes.array,
  urlMobile: PropTypes.string.isRequired,
  urlDesktop: PropTypes.string.isRequired,
};

InfoBanner.defaultProps = {
  section: '',
  tittle: '',
  readingTime: '',
  keywords: [],
  urlMobile: '',
  urlDesktop: '',
};

export default InfoBanner;
